import Vue from "vue";
import Router from "vue-router";
import Homepage from "@/components/Homepage";
import Register from "@/components/Register";
import Doctors from "@/components/Doctors";
import Patients from "@/components/Patients";
import Institutions from "@/components/Institutions";
import Forum from "@/components/Forum";
import ForumRegister from "@/components/ForumRegister";
import ForumOnline from "@/components/ForumOnline";
import ForumOnlineSuccess from "@/components/ForumOnlineSuccess";
import ForumProgram from "@/components/ForumProgram";
import ForumRegulations from "@/components/ForumRegulations";
import ForumRegisterSuccess from "@/components/ForumRegisterSuccess";
import ForumRegisterFail from "@/components/ForumRegisterFail";
import ForumCertificate from "@/components/ForumCertificate";
import Ambasadors from "@/components/Ambasadors";
import Regulations from "@/components/Regulations";
import Transmission from "@/components/Transmission";
import PatientsNumber from "@/components/PatientsNumber";
import "babel-polyfill";
import PressConference from "../components/PressConference";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Homepage",
      component: Homepage
    },
    {
      path: "/rejestracja-gabinetu",
      name: "Register",
      component: Register
    },
    {
      path: "/dla-lekarza",
      name: "Doctors",
      component: Doctors
    },
    {
      path: "/dla-pacjenta",
      name: "Patients",
      component: Patients
    },
    {
      path: "/lista-gabinetow",
      name: "Institutions",
      component: Institutions
    },
    {
      path: "/forum-jaskry",
      name: "Forum",
      component: Forum
    },
    {
      path: "/forum-jaskry/rejestracja",
      name: "ForumRegister",
      component: ForumRegister
    },
    {
      path: "/forum-jaskry/rejestracja-online",
      name: "ForumOnline",
      component: ForumOnline
    },
    {
      path: "/forum-jaskry/potwierdzenie-online",
      name: "ForumOnlineSuccess",
      component: ForumOnlineSuccess
    },
    {
      path: "/forum-jaskry/potwierdzenie",
      name: "ForumRegisterSuccess",
      component: ForumRegisterSuccess
    },
    {
      path: "/forum-jaskry/odrzucenie",
      name: "ForumRegisterFail",
      component: ForumRegisterFail
    },
    {
      path: "/forum-jaskry/program",
      name: "ForumProgram",
      component: ForumProgram
    },
    {
      path: "/forum-jaskry/regulamin",
      name: "ForumRegulations",
      component: ForumRegulations
    },
    {
      path: "/forum-jaskry/transmisja/:token",
      name: "ForumCertificate",
      component: ForumCertificate
    },
    {
      path: "/forum-jaskry/transmisja",
      name: "Transmission",
      component: Transmission
    },
    {
      path: "/ambasadorzy",
      name: "Ambasadors",
      component: Ambasadors
    },
    {
      path: "/regulamin",
      name: "Regulations",
      component: Regulations
    },
    {
      path: "/gabinet/liczba-pacjentow/:id",
      name: "PatientsNumber",
      component: PatientsNumber
    },
    {
      path: "/konferencja-prasowa",
      name: "PressConference",
      component: PressConference
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js